/* eslint-disable */
import { BiPencil } from "react-icons/bi";
import { BsCodeSlash, BsClipboardData } from "react-icons/bs";
import { AiOutlineDatabase } from "react-icons/ai";
import { FaLaptopCode, FaCogs, FaWordpress } from "react-icons/fa";

export const servicesData = [
    {
        id: 1,
        title: 'Web Design',
        icon: <BsCodeSlash />
    },
    {
        id: 2,
        title: 'Web Development',
        icon: <FaLaptopCode />
    },
    {
        id: 3,
        title: 'Custom Software Solutions',
        icon: <FaCogs />
    },
    {
        id: 4,
        title: 'CMS Management',
        icon: <FaWordpress />
    },
    {
        id: 5,
        title: 'Accounting Software',
        icon: <BsClipboardData />
    },
    {
        id: 6,
        title: 'Content Writing',
        icon: <BiPencil />
    },
    {
        id: 7,
        title: 'Database Design',
        icon: <AiOutlineDatabase />
    },
]
